import { AxiosResponse } from 'axios';
import { stringify } from 'qs';
import IReportsHistoricResponse from '../../../interfaces/reports/IReportsHistoricResponse';
import IPagination from '../../../interfaces/IPagination';
import { getRoundManagerApiAxiosInstance } from '../../axios-config';
import IPaginatedRequest from '../../../interfaces/IPaginatedRequest';
import IApiResponse from '../../../interfaces/IApiResponse';
import i18n from '../../../../lib/i18n';

export const getHistoricListAsync = async (
    page: number,
    pageSize: number,
): Promise<IApiResponse<IPagination<IReportsHistoricResponse>>> => {
    const request: IPaginatedRequest = {
        _page: page,
        _size: pageSize,
    };

    try {
        const Api = await getRoundManagerApiAxiosInstance();

        const response = await Api.get('v1/reports/historic:paginated', {
            params: request,
            paramsSerializer(params) {
                return stringify(params, { allowDots: true });
            },
        });

        if (response.data) {
            return { response: response.data };
        }

        return {
            error: new Error(i18n.t('Reports.ErrorGettingReportsHistory')),
        };
    } catch (error: any) {
        return {
            error: new Error((error as { message: string }).message),
        };
    }
};

export const downloadReportAsync = async (
    reportType?: string,
    startDateFilter?: string,
    endDateFilter?: string,
    channel?: string,
): Promise<IApiResponse<boolean>> => {
    const request = {
        _type: reportType,
        _initialDate: startDateFilter,
        _finalDate: endDateFilter,
        _channel: channel,
    };

    try {
        const Api = await getRoundManagerApiAxiosInstance();

        const response = await Api.get('v1/reports:export', {
            params: request,
        });

        if (response?.data) {
            const fileName = getFileName(response);

            downloadFile(response.data, fileName);

            return { response: true };
        }

        return {
            error: new Error(i18n.t('Reports.ErrorGettingReport')),
        };
    } catch (error: any) {
        return {
            error: new Error((error as { message: string }).message),
        };
    }
};

const downloadFile = (data: any, filename: string) => {
    const bom = '\uFEFF';
    const csvContent = bom + data;

    const contentType = 'text/csv;charset=utf-8;';
    const csvFile = new Blob([csvContent], { type: contentType });

    const url = window.URL.createObjectURL(csvFile);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
};

const getFileName = (response: AxiosResponse | undefined) => {
    const contentDisposition = response?.headers['content-disposition'];
    const fileNameMatch = contentDisposition
        .split(';')[1]
        .split('=')[1]
        .replace('"', '')
        .replace('"', '');
    return `${fileNameMatch}`;
};
